import { useEffect, useRef, useMemo } from "react";

import { BreadcrumbItem } from "../types";

export const useDocumentTitleFromBreadcrumbs = (items: BreadcrumbItem[], enabled = true): void => {
  const originalTitle = useRef<string | null>(null);
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);

  const lastItemLabel = useMemo(() => {
    const lastItem = items[items.length - 1];
    return lastItem?.label || null;
  }, [items]);

  useEffect(() => {
    if (!enabled || !lastItemLabel) {
      return;
    }

    if (originalTitle.current === null) {
      originalTitle.current = document.title;
    }

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      document.title = lastItemLabel;
    }, 300);

    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
      if (originalTitle.current !== null) {
        document.title = originalTitle.current;
      }
    };
  }, [lastItemLabel, enabled]);

  useEffect(
    () => () => {
      originalTitle.current = null;
    },
    [],
  );
};
